/**
 * Contact routes. The route cards are submit buttons of a GET form, so without
 * JS a click loads ?about=<key>. This switches in place instead: the pressed
 * card, the address, the form card's tag, heading and intro, the Gravity Forms
 * Reason field (which drives the council and reference fields through the
 * form's conditional logic), the message label and the button label.
 *
 * After a send Gravity Forms replaces the form with its confirmation; step 3
 * lights, and a route click from then on loads the page on that route, since
 * there is no form left to switch.
 */

const formIdIn = (card) => {
	const wrap = card.querySelector('[id^="gform_wrapper_"]');
	return wrap ? parseInt(wrap.id.replace('gform_wrapper_', ''), 10) : 0;
};

export default function initContact() {
	document.querySelectorAll('[data-awdd-route-list]').forEach((list) => {
		const section = list.closest('section');
		const card = section ? section.querySelector('[data-contact-form]') : null;
		const buttons = Array.from(list.querySelectorAll('[data-awdd-route]'));
		if (!section || !card || !buttons.length) return;
		const steps = Array.from(section.querySelectorAll('[data-awdd-contact-steps] > li'));
		let confirmed = false;

		const swapCopy = (b) => {
			const tag = card.querySelector('[data-awdd-contact-tag]');
			const heading = card.querySelector('[data-awdd-contact-heading]');
			const intro = card.querySelector('[data-awdd-contact-intro]');
			if (tag) { tag.textContent = b.dataset.awddRouteTag || ''; tag.hidden = !b.dataset.awddRouteTag; }
			if (heading) heading.textContent = b.dataset.awddRouteHeading || '';
			if (intro) { intro.textContent = b.dataset.awddRouteIntro || ''; intro.hidden = !b.dataset.awddRouteIntro; }
			const formId = formIdIn(card);
			if (!formId) return;
			const reason = card.querySelector('input[name="input_1"]');
			if (reason) {
				reason.value = b.dataset.awddRoute;
				if (window.jQuery) window.jQuery(reason).trigger('change');
				if (typeof window.gf_apply_rules === 'function') window.gf_apply_rules(formId, [4, 5]);
			}
			const label = card.querySelector(`label[for="input_${formId}_6"]`);
			if (label && b.dataset.awddRouteFieldLabel) label.textContent = b.dataset.awddRouteFieldLabel;
			const button = card.querySelector(`#gform_submit_button_${formId} [data-awdd-button-label]`);
			if (button && b.dataset.awddRouteButtonLabel) button.textContent = b.dataset.awddRouteButtonLabel;
		};

		const urlFor = (key) => {
			const url = new URL(window.location.href);
			url.searchParams.set('about', key);
			url.hash = '';
			return url;
		};

		const pick = (b) => {
			const key = b.dataset.awddRoute;
			if (confirmed) {
				const next = urlFor(key);
				next.hash = 'contact-form';
				// Only the fragment would differ when the address already carries this route: assign would scroll, not reload.
				if (next.href.split('#')[0] === window.location.href.split('#')[0]) {
					window.location.replace(next.href);
					window.location.reload();
				} else {
					window.location.assign(next.href);
				}
				return;
			}
			buttons.forEach((x) => x.setAttribute('aria-pressed', x === b ? 'true' : 'false'));
			swapCopy(b);
			window.history.replaceState(null, '', urlFor(key));
		};

		buttons.forEach((b) => b.addEventListener('click', (e) => {
			e.preventDefault();
			pick(b);
		}));

		// Gravity Forms announces its AJAX confirmation through a jQuery event.
		if (window.jQuery) {
			window.jQuery(document).on('gform_confirmation_loaded', (e, formId) => {
				if (parseInt(formId, 10) !== formIdIn(card) && !card.querySelector('.gform_confirmation_message')) return;
				confirmed = true;
				steps.forEach((li, i) => {
					const dot = li.querySelector('span');
					if (i === 2 && dot) dot.setAttribute('data-on', '');
					if (i === 2) li.setAttribute('aria-current', 'step');
					else li.removeAttribute('aria-current');
				});
			});
		}
	});
}
